import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sellerCommunicationSubheader: {
    defaultMessage: 'Account Communication',
    description: 'header for a section that contains the contact methods for the merchant account',
    id: '6lEg+V',
  },
  phoneInputLabel: {
    defaultMessage: 'Contact Phone Number',
    description: 'label for an input that has a phone number',
    id: 'eq2C+7',
  },
  saveButton: {
    defaultMessage: 'Save',
    description: 'text for a save button',
    id: 'ZR7yTg',
  },
  saving: {
    defaultMessage: 'Saving',
    description: 'text for a button that is in the process of saving',
    id: 'JlThIl',
  },
  editButton: {
    defaultMessage: 'Edit',
    description: 'text for an edit button',
    id: '1hcaSk',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    description: 'text for a cancel button',
    id: 'xib4n1',
  },
  consentCheckboxLabel: {
    defaultMessage: 'I would like to receive support and updates from ShipStation via SMS.',
    description: 'Label for the SMS consent checkbox',
    id: 'yNvvAI',
  },
});
